import { usePostMessage } from '@ps/web-shared-components';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

const NotFound: React.FC<RouteComponentProps> = () => {
  const { modal } = useDispatch<Dispatch>();
  const embeddedModal = useSelector(select.location.isEmbeddedModal);
  const postMessage = usePostMessage();

  useEffect(() => {
    if (embeddedModal) {
      postMessage('close');
      window.close();
    } else {
      modal.close();
    }
  }, [modal, embeddedModal, postMessage]);

  return null;
};

export default NotFound;
